<!--
이미지 변경 컴포넌트 > 첨부파일중 선택 방식
-->
<template>
    <!-- 폼 화면 -->
    <div class="uk-flex-top" uk-modal esc-close="false" bg-close="false">
        <div class="uk-modal-dialog uk-margin-auto-vertical uk-width-xxlarge">

            <div class="uk-modal-header">
                <h4 class="uk-text-center">이미지를 선택하세요</h4>
            </div>

            <div class="uk-modal-body">

                <div class="uk-flex uk-flex-around uk-flex-wrap">
                    <!-- 이미지 표시 -->
                    <div
                        v-for="file in uploaded_files"
                        :key="file.id"
                        class="uploaded-image"
                        :class="selected && selected.id === file.id ? 'selected' : null"
                        @click="selected = file"
                    >
                        <img
                            :src="file.url"
                            :data-src="file.url"
                            class=" lazyloaded"
                        />

                        <!-- 파일명 -->
                        <div class="file-name" :title="file.name">
                            {{ file.name }}
                        </div>
                    </div>

                </div>

            </div>


            <div class="uk-modal-footer uk-text-right">

                <!--- 버튼 -->
                <button
                    type="button"
                    class="uk-button uk-button-default uk-modal-close"
                >
                    <span uk-icon="icon: close"></span> 취소
                </button>

                <button
                    type="button"
                    class="uk-button uk-button-primary"
                    v-on:click="submit()"
                    :disabled="! submitReady"
                >
                    <span uk-icon="icon: check"></span>
                    저장
                </button>
            </div>
        </div>
    </div>

</template>

<script>
    export default {
        props: {
            // csrf-token
            csrfToken: String,
        },
        data: function () {
            return {
                // (object) 상품정보
                prod: {},

                // [] 첨부파일배열
                uploaded_files: [],

                // (object) 선택된 이미지객체
                selected: null,
            };
        },
        computed: {
            /**
             * 서브밋 준비가 완료되었는지 여부
             * @return bool
             */
            submitReady() {
                return Boolean(this.selected);
            },
        },
        methods: {
            /**
             * 입력폼 display
             */
            displayForm() {

                UIkit.modal(this.$el).show();
            },

            /**
             * 폼
             * @param prod 상품
             */
            form(prod) {
                this.prod = prod;

                // promise 생성
                let load = new Promise((resolve, reject) => {
                    //reject('failed !');

                    // ajax 옵션
                    let opts = {
                        type: 'get',
                        url: '/files',
                        contentType: 'application/json',
                        data: {
                            'prod_id': this.prod.id,
                        },
                        success: (response, textStatus, jqXHR) => {
                            // promise 성공
                            resolve(response);
                        },
                    };

                    // ajax 실행
                    $.app.ajax.module.background(opts);
                });


                // promise 처리
                load.then((response) => {
                    this.uploaded_files = _.filter(response.uploaded_files, {'is_img': 1});

                    // 폼띄우기
                    this.displayForm();
                });


            },


            /**
             * submit
             */
            submit() {
                if (! this.selected) {
                    alert('이미지를 선택하세요');
                    return;
                }

                // promise 생성
                let load = new Promise((resolve, reject) => {

                    // ajax 옵션
                    let opts = {
                        type: 'patch',
                        url: '/prods/' + this.prod.id + '/image',
                        data: {
                            '_token': this.csrfToken,
                            'file_id': this.selected.id,
                        },
                        success: (response, textStatus, jqXHR) => {
                            // promise 성공
                            resolve(response);
                        },
                    };

                    // ajax 실행
                    $.app.ajax.module.default(opts);
                });

                // promise 처리
                load.then((response) => {
                    UIkit.modal.alert(response.msg).then(() => {
                        $.app.refresh();
                    });
                });
            },

        },


    }
</script>

<style lang="scss" scoped>
    .uploaded-image {
        width: 150px;
        margin: 10px;
        padding: 10px;
        cursor: pointer;
        text-align: center;
        border: 1px solid #cfcfcf;

        &:hover {
            background-color: #666;
            color: #fff;
        }
        &.selected {
            background-color: #333;
            color: #fff;
        }


        img {
            object-fit: contain;
            width: 120px;
            height: 120px;
        }

        // 파일명
        .file-name {
            margin-top: 10px;
            text-align: center;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }
    }
</style>